var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing;
  return {
    feedbackTextColor: colors.white,
    feedbackCorrectColor: colors.shamrock,
    feedbackIncorrectColor: colors.crimson,
    feedbackUnknownColor: colors.slate,
    feedbackTextMargin: spacing.xSmall,
    feedbackTopBottomPadding: spacing.xSmall,
    feedbackLeftRightPadding: spacing.small
  };
};
export default generateComponentTheme;